import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './authentication/Login';
import Register from './registration/Register';
import Home from './home/Home';
import ProtectedRoutes from './ProtectedRoutes';
import { ThemeProvider } from '@emotion/react';
import LightTheme from './theme/LightTheme';
import { setupAxiosInterceptors } from './axiosSetup';
import './App.css';
import ConfirmRegistration from './registration/ConfirmRegistration';
import ResetPassword from './authentication/ResetPassword';

const NotFound: React.FC = () => <div>404 - Page Not Found</div>;

const App: React.FC = () => {

  setupAxiosInterceptors();

  return (
    <ThemeProvider theme={LightTheme}>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/confirmregistration" element={<ConfirmRegistration />} />
          <Route path="/resetpassword" element={<ResetPassword />} />

          {/* Wrap protected routes */}
          <Route
            path="/"
            element={
              <ProtectedRoutes>
                <Suspense fallback={<div>Loading...</div>}>
                  <Home />
                </Suspense>
              </ProtectedRoutes>
            }
          />
          <Route
            path="/home"
            element={
              <ProtectedRoutes>
                <Suspense fallback={<div>Loading...</div>}>
                  <Home />
                </Suspense>
              </ProtectedRoutes>
            }
          />
          <Route
            path="/places/:id"
            element={
              <ProtectedRoutes>
                <Suspense fallback={<div>Loading...</div>}>
                  {/* <PublicUserPlaceDetails /> */}
                </Suspense>
              </ProtectedRoutes>
            }
          />

          {/* Catch-all route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

export default App;